import './HeaderGenericPrimary.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const videoWhiteOverlayTime = 750;
const videoFadeTime = 400;
const HeaderGenericPrimary = _ref => {
  let {
    rendering,
    fields,
    children,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    "--m57-header-generic-primary-background-color": BackgroundColorHex,
    "--m57-header-generic-primary-background-active-color": ActiveColorHex,
    "--m57-header-generic-primary-color": ColorHex
  } : {
    "--m57-header-generic-primary-background-color": selectedPrimaryColor,
    "--m57-header-generic-primary-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-header-generic-primary-color": getColorByTheme(selectedPrimaryColor)
  };
  if (!fields) {
    console.warn('HeaderGenericPrimary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }

  // 2 different sets of fields may come
  //
  const pageTitle = get(fields, 'pageTitle');
  const pageIntro = get(fields, 'pageIntro');
  const actualPageTitle = pageTitle && pageTitle.value ? pageTitle : get(fields, 'Title');
  const actualPageIntro = pageIntro && pageIntro.value ? pageIntro : get(fields, 'Intro Text');
  const hasTitle = Boolean(actualPageTitle.value);
  const hasIntroText = Boolean(actualPageIntro.value);
  //

  const ctaLink = get(fields, 'ctaLink.value.href');
  const ctaLabel = get(fields, 'ctaLabel.value');
  const mediaDesc = hasTitle ? actualPageTitle.value : hasIntroText ? actualPageIntro.value : '';
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-primary",
      rendering: rendering,
      mediaDesc: mediaDesc
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--primary",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__media"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 header-content__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-content theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg theme-contrast"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-content__main header-animation__content"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "c-content__title",
    field: actualPageTitle
  }), hasIntroText && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "c-content__text",
    field: actualPageIntro
  }), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-secondary c-content__btn desktop__link",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-primary mob__link",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  })))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `header-animation ${commonStyles} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles}  ${headerImageStyle}`,
    removePaddingHeader: true,
    componentTabIndex: "disabled"
  }, children);
};
export const commonStyles = "c1tvdg7s";
export const ltrStyles = "l1jitq1y";
export const rtlStyles = "ruzjhmt";
export default HeaderGenericPrimary;